import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSd = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 6", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 12, height: 6 }), /* @__PURE__ */ React.createElement("rect", { fill: "#FFF", width: 12, height: 4 }), /* @__PURE__ */ React.createElement("rect", { fill: "#D21034", width: 12, height: 2 }), /* @__PURE__ */ React.createElement("polygon", { fill: "#007229", points: "0,0 4,3 0,6" }));
const ForwardRef = forwardRef(SvgSd);
const Memo = memo(ForwardRef);
export default Memo;
